import type { ContentReactionType } from "@circle-react/types/ContentReaction";

import {
  fetchRequest,
  type FetchOptions,
} from "@/react/helpers/backendRequestHelpers";
import { userLikes } from "@/react/helpers/urlHelpers";

export type UserLikableType = "Comment" | "Post";

interface UserLikeRequestOptions extends FetchOptions {
  userLikableType: UserLikableType;
  userLikeableId: number;
}

interface CreateUserLikeOptions extends UserLikeRequestOptions {
  reactionType?: ContentReactionType;
}

const create = ({
  userLikeableId: user_likeable_id,
  userLikableType: user_likeable_type,
  reactionType: reaction_type,
  ...fetchRequestOptions
}: CreateUserLikeOptions) =>
  fetchRequest(userLikes.create(), {
    method: "POST",
    ...fetchRequestOptions,
    body: JSON.stringify({
      user_likeable_type,
      user_likeable_id,
      reaction_type,
    }),
  });

const destroy = ({
  userLikeableId: user_likeable_id,
  userLikableType: user_likeable_type,
  ...fetchRequestOptions
}: UserLikeRequestOptions) =>
  fetchRequest(userLikes.destroy(), {
    method: "DELETE",
    ...fetchRequestOptions,
    body: JSON.stringify({
      user_likeable_type,
      user_likeable_id,
    }),
  });

export const userLikeApi = {
  create,
  destroy,
};
